import React from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


ReactDOM.render(
    <HelmetProvider><App /></HelmetProvider>,
    document.getElementById('root')
);

reportWebVitals();
